import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsCut = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M44.882 24 38.766 9.234 24 3.118 9.234 9.234 3.118 24l6.116 14.766L24 44.882l14.765-6.116zM24 44.881 21.689 26.31 3.118 24l18.571-2.311L24 3.118l2.311 18.571L44.882 24l-18.571 2.311z" }) }) })
});
export default SvgMetricsCut;
